import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Checkbox @checked={{this.checked}} class=\"mr-8\" />\n{{yield}}", {
  moduleName: "@qonto/ui-kit/components/power-select-customs/multiple/option.hbs"
});